import { type ComponentProps, type ComponentType, memo } from 'react';

type PropsComparator<C extends ComponentType> = (
  prevProps: Readonly<ComponentProps<C>>,
  nextProps: Readonly<ComponentProps<C>>,
) => boolean;

// oxlint-disable-next-line typescript/no-explicit-any
export function typedMemo<C extends ComponentType<any>>(Component: C, propsComparator?: PropsComparator<C>) {
  // oxlint-disable-next-line eslint-js/no-restricted-syntax
  return memo(Component, propsComparator) as unknown as C;
}
